/*
 * Created on Fri Jul 15 2022
 *
 * Copyright (c) 2022 Khor Chai Hong
 */

import animateScroll from "./animateScroll";

export default function scrollTo({ ref, addOffsetTop = 0, duration = 350 }) {
    // target position
    const targetPosition = ref.current.getBoundingClientRect().top + window.scrollY - addOffsetTop;
    // initial position of scroll bar
    const initialPosition = window.scrollY;

    return animateScroll({
        targetPosition,
        initialPosition,
        duration
    });
};
